import { GoalsInput } from '@cpd-app/generated';

/**
 * CPD-665. ONE CREDENTIAL GOAL, TWO COLUMNS BEHIND IT.
 *
 * `api.usergoals` carries both `certificationid` -- CPD's own catalogue, set
 * from the certification picker under Schools and Programs -- and
 * `credential_ctid`, the national Credential Registry id CRED.1 added under
 * Relevant Credentials. The checklist has never had two rows for them: one
 * "Credential goal" row prints `credentialTitle || certificationTitle`.
 *
 * Nothing kept the two columns in step. `updateGoals$` merges each change onto
 * the goals already on file, so setting a Registry credential left a
 * certification standing and setting a certification left the credential
 * standing. Both cards then read as chosen, the checklist printed whichever
 * won the fallback, and the masthead counted the member 6 of 6 for five rows
 * -- Phong reached 6/6 with one career, one school, one program and what
 * looked like two certifications.
 *
 * So the rule lives here, in one place, rather than as two halves of two
 * effects that already drifted apart once: SETTING EITHER CLEARS THE OTHER.
 * A pure function of the change rather than of the stored goals, because that
 * is all it needs -- whatever is on file, the column this write does not own
 * ends up null.
 */

/**
 * The goals change for "the member chose a certification", or cleared one.
 *
 * Clearing nulls the Registry credential too. The member pressed Remove on a
 * row, not on a column, and a row that redraws with the other column's text is
 * the CPD-661 item 5 complaint over again from the other side.
 */
export function certificationGoalChange(
  certificationId: string | null
): GoalsInput {
  return {
    certificationId,
    credentialCtid: null,
    credentialTitle: null
  };
}

/**
 * The goals change for "the member chose a Registry credential", or cleared one.
 *
 * CPD-661 item 5 nulled the certification only when the credential was being
 * REMOVED, which fixed Remove and left Set broken: choosing a credential on
 * top of a certification produced the two-goals-in-one-row state above. The
 * guard is gone; the clear is unconditional in both directions.
 */
export function credentialGoalChange(
  credentialCtid: string | null,
  credentialTitle: string | null
): GoalsInput {
  return {
    credentialCtid,
    credentialTitle,
    certificationId: null
  };
}
